import Settings from '@/routes/Settings';
import Index from './Index';

import { BrowserRouter, Route, Routes } from 'react-router';

export default function Router() {
    return (
        <BrowserRouter>
            <Routes>
                <Route index element={<Index />} />
                <Route path="/settings" element={<Settings />} />
            </Routes>
        </BrowserRouter>
    );
}
